import { LOCATION_CHANGE } from "../../_Bootstrap/GlobalConstants";
import {
    DIALOG_HIDE,
    DIALOG_SHOW,
    type DialogActionTypes,
    type DialogState,
} from "../../Actions/Dialogs/DialogActions";
import {
    LAYOUT_BODY_CLICK,
    LAYOUT_NOTIFICATIONS_TOGGLE,
    LAYOUT_TOGGLE_MENU,
    LAYOUT_USER_MENU_TOGGLE,
} from "../../Actions/General/LayoutActions";
import { type ShopfrontActions } from "../../Utilities/Generic/ActionsHelper";

function DialogReducer(state: DialogState | undefined, action: ShopfrontActions<DialogActionTypes>): DialogState {
    if(typeof state === "undefined") {
        return {
            visible: false,
        };
    }

    switch(action.type) {
        case DIALOG_SHOW:
            return {
                visible: true,
                // THIS IS INTENTIONAL
                ...action.data,
            };
        case LAYOUT_TOGGLE_MENU:
        case LAYOUT_BODY_CLICK:
        case LAYOUT_USER_MENU_TOGGLE:
        case LAYOUT_NOTIFICATIONS_TOGGLE:
            if(!state.closeable) {
                return state;
            }

            return {
                visible: false,
            };
        case LOCATION_CHANGE:
            return {
                visible: false,
            };
        case DIALOG_HIDE:
            if(typeof action.delay === "number") {
                return {
                    ...state,
                    visible: false,
                    delay  : action.delay,
                };
            }

            return {
                visible: false,
            };
        default:
            return state;
    }
}

export default DialogReducer;
